import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";

const steps = [
  {
    number: "1",
    title: "Create Your Account",
    description: "Sign up in minutes. All you need is a wallet or email.",
  },
  {
    number: "2",
    title: "Fund & Allocate",
    description: "Deposit GBP/USD or crypto. Allocate to the AurØra portfolio.",
  },
  {
    number: "3",
    title: "Earn Property Income",
    description: "Sit back and track your income — paid on-chain, automatically.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 lg:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-full">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h3 className="text-lg md:text-xl font-normal mb-4 text-foreground">
            How AurØra Works?
          </h3>
          <p className="text-foreground/70 text-sm md:text-base mb-8">
            From sign-up to rental income in minutes—no banks, no paperwork, just real yield.
          </p>
          <a href="#waitlist" className="inline-block glow-radial-strong">
            <Button variant="hero" size="lg" className="rounded-full px-8">
              Get Early Access
              <ArrowUpRight className="ml-2 w-4 h-4" />
            </Button>
          </a>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="relative group animate-fade-up text-center"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Number */}
              <div className="text-5xl font-light text-primary mb-4">
                {step.number}
              </div>

              <h4 className="font-medium text-base mb-2 text-foreground">
                {step.title}
              </h4>
              <p className="text-foreground/70 text-sm">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
